import React, { useEffect } from "react";
import DriverTitle from "./DriverTitle";
import { useDispatch, useSelector } from "react-redux";
import { CONSTANTS } from "client/utils/constants";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";

const DriverTitleContainer = (props: any) => {
    const dispatch = useDispatch();
    const initialList: any = [];
    const { reasonList }: any = useSelector((state?: any) => ({
        reasonList: state.RequisitionReducer.reasonList,
    }));
    const [list, setList] = React.useState(initialList);
    const [name, setName] = React.useState('');
    const [error, setError] = React.useState({ maxLengthError: '', driverCountError: '' });

    useEffect(() => {
        setList(props.request.vehicleDriverDetails)
    }, [])

    useEffect(() => {
        let currentError = JSON.parse(JSON.stringify(error));
        currentError = validateDriverName(list, currentError)
        setError({ ...currentError });
    }, [reasonList])

    function validateDriverName(newList: any, currentError: any) {
        let reasonCount = 0;
        for (let i = 0; i < reasonList.length; i++) {
            if (reasonList[i]?.requestIndex === props.request?.requestIndex && reasonList[i]?.requestType === CONSTANTS.MANAGEMENT_VEHICLE) {
                reasonCount = reasonCount + 1
            }
        }
        if (newList.length > reasonCount) {
            return { ...currentError, driverCountError: "Please increase the quantity to add driver" }
        } else {
            return { ...currentError, driverCountError: "" }
        }
    }

    function validateMaxLength(currentName: any, currentError: any) {
        if (currentName?.trim() != "" && currentName.length > 50) {
            return { ...currentError, maxLengthError: "Please enter driver less then 50 characters" }
        } else {
            return { ...currentError, maxLengthError: "" };
        }
    }

    function onChange(event: any) {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        let currentName = event.target.value;
        setName(currentName);
        let currentError = JSON.parse(JSON.stringify(error));
        currentError = validateMaxLength(currentName, currentError);
        let newList = list.concat({
            orderRequestVehicleDriverId: 0,
            employeeNumber: null,
            employeeFullName: currentName
        });
        currentError = validateDriverName(newList, currentError)
        setError({ ...currentError });
    }

    function onAdd(e: any) {
        dispatch(RequisitionAction.setIsChangesOccured(true))
       
        const newList = list.concat({
            orderRequestVehicleDriverId: 0,
            employeeNumber: null,
            employeeFullName: name
        });
        setList(newList);
        setName('');
        props.addDriverDetails(props.request, newList)
        props.onDriverCloseLinkAttachment(e)
    }

    const removeDrivername = (itemIndex: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        const arr: any = JSON.parse(JSON.stringify(list));
        arr.splice(itemIndex, 1);
        setList(arr);
        props.addDriverDetails(props.request, arr)
        let currentError = JSON.parse(JSON.stringify(error));
        currentError = validateDriverName(arr, currentError)
        setError({ ...currentError });
    };

    return (
        <DriverTitle
            onDriverCloseLinkAttachment={props.onDriverCloseLinkAttachment}
            onAdd={onAdd}
            onChange={onChange}
            name={name}
            list={list}
            removeDrivername={removeDrivername}
            error={error}
        />
    )
}

export default DriverTitleContainer;